import { endpoints } from 'constants/endpoints';

import { sendRequest } from '../sendRequest';

export const getFiltersApi = () => {
  const url = endpoints.analytics.continuousFeedback.filters;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getContinuousFeedbackApi = ({
  queryParams,
  cohort,
  groupByKeys,
  splitByKeys,
  graphType,
  parentUuid,
  dateRange,
}) => {
  const url = endpoints.analytics.continuousFeedback.tabularData;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams,
    body: { cohortId: cohort?.id, groupByKeys, splitByKeys, graphType, dateRange, parentUuid },
  });
};
